__turbopack_context__.v({
  "eyebrow": "MobileAppDevelopmentServicesCardSection-module__FGDWzq__eyebrow",
  "section": "MobileAppDevelopmentServicesCardSection-module__FGDWzq__section",
  "title": "MobileAppDevelopmentServicesCardSection-module__FGDWzq__title",
});
